module.exports = __webpack_public_path__ + "img/14_debris.4e3b715b.jpg";